export default __webpack_public_path__ + "static/media/dsdLogoTrans.b7873d09.png";